import React from 'react';
import { PlayIcon } from 'components/Icons/PlayIcon';
import createAccessibleOnClick, { BTN } from 'utils/createAccessibleOnClick';
import styles from './PlayButtonOverlay.module.scss';

export interface PlayButtonOverlayProps {
  visible: boolean;
  onClick: () => void;
  testId?: string;
}

const PlayButtonOverlay: React.FC<PlayButtonOverlayProps> = ({
  visible,
  onClick,
  testId = 'play-button-overlay',
}) => {
  if (!visible) return null;

  return (
    <div
      className={styles.playButtonOverlay}
      {...createAccessibleOnClick(onClick, BTN)}
      data-testid={testId}
    >
      <div className={styles.buttonContainer}>
        <PlayIcon />
      </div>
    </div>
  );
};

export default PlayButtonOverlay;
